import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  dbConfigurationsSlice,
  userInfoSlice,
  userInstrumentsServices,
  userInstrumentsSlice,
} from '!core/redux';
import { handleSagaError } from '»utils/handleSagasError';
import { navigate } from '»utils/navigation';

import { menusSlice } from '../../Menus';
import { authSlice } from '../redux';
import { otpService } from './otp.services';
import { otpSlice } from './otp.slice';

const validateLoginOtpWorker = function* ({ payload }) {
  try {
    const { username, loginId, otp } = payload;

    yield call(otpService.validateLoginOtp, {
      username,
      loginId,
      otp,
    });

    const userInstrumentsData = yield call(
      userInstrumentsServices.userInstruments,
    );

    yield all([
      put(menusSlice.actions.menuRequest()),
      put(userInfoSlice.actions.userInfoRequest()),
      put(
        userInstrumentsSlice.actions.userInstrumentsSucess(userInstrumentsData),
      ),
      put(
        dbConfigurationsSlice.actions.dbConfigurationsRequest({
          detailIds: [
            'PRIM_EXPIRE_TIME',
            'CONTACT_TYPE_TMOVEL',
            'CONTACT_TYPE_EMAIL',
            'CLIENT_SUPPORT_PHONE_NUMBER',
            'HAS_FUNDS',
          ],
          parameterId: 'CR_CHNN_UI',
          noAuth: false,
        }),
      ),
      put(otpSlice.actions.validateLoginOtpSuccess()),
    ]);

    // eslint-disable-next-line no-undef
    const myConfig = config();
    const { showTermsAndConditions } = myConfig;

    if (showTermsAndConditions) {
      yield put(
        authSlice.actions.getUserProcessRequest({ processId: 'COND_GERAIS' }),
      );
    } else {
      navigate('/Dashboard');
      yield put(
        menusSlice.actions.setActiveMenuItem({ activeMenuItem: 'DASHBOARD' }),
      );
    }
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(otpSlice.actions.validateLoginOtpFailure());
  }
};

export const otpSagas = function* () {
  yield takeLatest(
    otpSlice.actions.validateLoginOtpRequest.type,
    validateLoginOtpWorker,
  );
};
